<template>
  <div class="flex flex-col overflow-x-auto">
    <div class="py-2 align-middle inline-block min-w-full">
      <div
        class="shadow border-b border-gray-200"
      >
        <table class="min-w-full divide-y divide-gray-200 table-auto">
          <thead class="">
            <tr>
              <th
                scope="col"
                class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite"
                v-for="t in thead"
                :key="t"
              >
                {{ t }}
              </th>
            </tr>
          </thead>
          <slot></slot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableAlt",
  props: {
    thead: {
      type: Array,
    },
    data: {
      type: Array,
    },
  },
};
</script>
<style scoped lang="scss">
  table{
    tr:nth-child(even) {background-color: #f2f2f2;}
  }
</style>